const partnerorganisations = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Partner Organisations",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Partner Organisations",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Organisation Added!",
              addNewSuccessMessage: "Organisation Added Successfully!",
              addNewErrorTitle: "Organisation Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Organisation Deleted!",
              deleteSuccessMessage: "Organisation Deleted Successfully!",
              deleteErrorTitle: "Organisation Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Organisation Activated!",
              activeSuccessMessage: "Organisation Activated Successfully!",
              activeErrorTitle: "Organisation Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Organisation Updated!",
              updateSuccessMessage: "Organisation Updated Successfully!",
              updateErrorTitle: "Organisation Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Partner Organisation",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Organisation Title",
                    placeholder: "Enter Organisation Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  organisation_image: "",
                  website_url: "",
                  contact_organisation_toggle: false,
                  phone_number: "",
                  address: "",
                },
              },
            },
            children: [
              {
                type: "memberPracticesTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Organisation Title",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Organisation Title",
                      placeholder: "Enter Organisation Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    picture: {
                      type: "imgSelect",
                      label: "Select Image",
                      placeholder: "Select Image",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    website_url: {
                      type: "text",
                      label: "Website URL",
                      placeholder: "Enter Website URL",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    contact_organisation_toggle: {
                      type: "toggle",
                      label: "Contact the organisation",
                      size: "12",
                      required: false,
                    },
                    phone_number: {
                      type: "text",
                      label: "Phone Number",
                      placeholder: "Phone Number",
                      displayOn: "contact_organisation_toggle",
                      displayOnValue: "true",
                      required: false,
                      info: false,
                      character_count: 10,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    address: {
                      type: "text",
                      label: "Address",
                      placeholder: "Enter Address",
                      displayOn: "contact_organisation_toggle",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { partnerorganisations };